import type { ActivityLogFilters } from './types';

/**
 * The Activity Type filter is contextual: the paired `name` filter (event name / attribute name /
 * free-text) is only meaningful for the currently selected type. So when the type changes, clear
 * `name` — otherwise a carried-over name silently filters the list down to nothing.
 */
export function filtersForTypeChange(type: string): Pick<ActivityLogFilters, 'type' | 'name'> {
  return { type, name: '' };
}
